"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Carousel = _interopRequireDefault(require("../Carousel"));

require("./styles.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var Listing = /*#__PURE__*/function (_React$Component) {
  _inherits(Listing, _React$Component);

  var _super = _createSuper(Listing);

  function Listing() {
    _classCallCheck(this, Listing);

    return _super.apply(this, arguments);
  }

  _createClass(Listing, [{
    key: "render",
    value: function render() {
      var cardClasses = "".concat((0, _classnames["default"])('card mb-3 border-0', {
        'col-md-6': this.props.halfWidth
      }), " ").concat(this.props.className || '');
      var imageClasses = (0, _classnames["default"])('card-img', {
        'portrait-listing-img': this.props.img && this.props.img.portrait
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: cardClasses
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row no-gutters"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.halfWidth ? 'col-md-6' : 'col-md-4'
      }, this.props.img ? Array.isArray(this.props.img) ? /*#__PURE__*/_react["default"].createElement(_Carousel["default"], {
        img: this.props.img,
        name: this.props.name
      }) : /*#__PURE__*/_react["default"].createElement("img", {
        src: this.props.img.src,
        className: imageClasses,
        alt: this.props.img.alt || ''
      }) : /*#__PURE__*/_react["default"].createElement("img", {
        src: "unavailable.jpg",
        className: "card-img",
        alt: ""
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.halfWidth ? 'col-md-6' : 'col-md-8'
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "card-body"
      }, this.props.footnote ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-2"
      }, /*#__PURE__*/_react["default"].createElement("h4", {
        className: "card-title mb-0"
      }, this.props.name), /*#__PURE__*/_react["default"].createElement("small", {
        className: "text-muted"
      }, this.props.footnote)) : /*#__PURE__*/_react["default"].createElement("h4", {
        className: "card-title"
      }, this.props.name), this.props.description && /*#__PURE__*/_react["default"].createElement("p", {
        className: "card-text"
      }, this.props.description), this.props.children, /*#__PURE__*/_react["default"].createElement("ul", null, this.props.points && this.props.points.map(function (pnt) {
        return /*#__PURE__*/_react["default"].createElement("li", null, pnt);
      }))))));
    }
  }]);

  return Listing;
}(_react["default"].Component);

var imagePropType = _propTypes["default"].shape({
  alt: _propTypes["default"].string,
  portrait: _propTypes["default"].bool,
  src: _propTypes["default"].string.isRequired
});

Listing.propTypes = {
  children: _propTypes["default"].node,
  description: _propTypes["default"].string,
  footnote: _propTypes["default"].string,
  halfWidth: _propTypes["default"].bool,
  img: _propTypes["default"].oneOfType([imagePropType, _propTypes["default"].arrayOf(imagePropType)]),
  name: _propTypes["default"].string.isRequired,
  points: _propTypes["default"].array
};
var _default = Listing;
exports["default"] = _default;